import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './shared/auth-m/core/auth.interceptor';
import { AuthService } from './shared/auth-m/core/auth.service';
import { EndUserAuthService } from './shared/auth-m/core/end-user-auth.service';
import { InvitedAuthService } from './shared/auth-m/core/invited-auth.service';
import { environment } from 'src/environments/environment';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';

export const appConfig: ApplicationConfig = {
  providers: [
    // The sessions are restored from storage by their services. Creating them
    // at startup means a restored session is refreshed, watched for inactivity
    // and listening for a sign-in elsewhere on every page — not only once some
    // component happens to inject its service.
    provideAppInitializer(() => {
      inject(AuthService);
      inject(InvitedAuthService);
      inject(EndUserAuthService);
    }),
    provideRouter(
      routes,
      withInMemoryScrolling({
          scrollPositionRestoration: "top",
      })
    ),
    provideAnimationsAsync(),
    // Auth-M functional interceptor: attaches the token of the request's session
    // (admin by default; invited / end-user when the request declares it) to
    // gateway calls and single-flight-refreshes on 401. It ignores requests
    // that aren't to the gateway or already carry an Authorization header.
    // (Replaces the old maw-auth AuthInterceptor.)
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaKey }
  ]

};
